import { get } from 'lodash'
import Request from '@w.dental/request'
import formatErrorMessages from 'helpers/formatErrorMessages'

const transformResponse = data => {
  if (data.hasError) {
    throw new Error(formatErrorMessages(data.messages))
  }
  return get(data, 'data.value')
}

export default Request(`${process.env.GATSBY_API}/api`, {
  interceptors: {
    transformResponse
  },
  headers: {
    'content-type': 'application/json'
  }
})
